import { Box, Checkbox as MuiCheckbox } from '@mui/material'
import theme from 'lib/theme'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Product } from 'types/model/product'

type CheckboxProps = {
  refundProductState: Product[] | []
  setRefundProductState: (value: Product[] | []) => void
  product: Product
}

export const Checkbox = ({
  refundProductState,
  setRefundProductState,
  product,
}: CheckboxProps) => {
  const { t } = useTranslation()
  return (
    <Box p={1}>
      <MuiCheckbox
        inputProps={{ 'aria-label': t('orderProduct.refundCheckbox') }}
        sx={{
          '&.Mui-checked .MuiSvgIcon-root': {
            fill: theme.palette.primary.main,
          },
        }}
        checked={Boolean(refundProductState.find((p) => p.id === product.id))}
        onClick={() =>
          refundProductState.find((p) => p.id === product.id)
            ? setRefundProductState(
                refundProductState.filter((p) => p.id !== product.id)
              )
            : setRefundProductState(
                refundProductState.length > 0
                  ? [...refundProductState, product]
                  : [product]
              )
        }
      />
    </Box>
  )
}
